import { store } from '@/store/store'
import amapi from '@/api/amapi'

export default {
  async showDomain (store, domain_id) {
    store.commit('SET_CURRENT_DOMAIN', domain_id)

    if (!store.getters.domainPopulated) {
      await store.dispatch('getDomain', domain_id)
    }
  },
  async getDomain ({ commit, dispatch, getters }, payload = { refresh: false }) {
    let domain_id
    if (!payload?.domain_id) {
      domain_id = getters.get_domain_id
    } else {
      domain_id = payload.domain_id
    }

    try {
      dispatch('unqueueDomain', domain_id)
      let query = await store.domaincache('domaindetail', { domain_id }, payload.refresh)
      if (query.result === 'success') {
        commit('POPULATE_DOMAIN', query.domain)
        return Promise.resolve()
      } else {
        if (query.resultmsg) {
          commit('POPULATE_DOMAIN',
            { 'id': domain_id, 'load_error': query.resultmsg })
        } else {
          commit('POPULATE_DOMAIN',
            { 'id': domain_id, 'load_error': 'Unexpected Error' })
        }
        return Promise.resolve()
      }
    } catch (e) {
      throw e
    }
  },
  async updateDomainStore (store, vals, sendRequest = true) {
    /*
    this is strictly to update values in vuex to speed up  UI and avoid  data
    inconsistency before new domain data is loaded.
    */
    const domain = {
      ...store.getters.domainCache.find(domain => domain.id === vals.domain_id),
      ...vals,
      updateCachedValue: true, // to update localStorage
    }
    store.commit('POPULATE_DOMAIN', domain) // quickly update the values
    if (sendRequest) {
      const payload = {
        domain_id: vals.domain_id,
        refresh: true,
      }
      await store.dispatch('getDomain', payload)
    }
    // in case they did not truely update.
  },
  queueDomain (store, domain_id) {
    store.commit('QUEUE_DOMAIN', domain_id)
  },
  unqueueDomain (store, domain_id) {
    store.commit('UNQUEUE_DOMAIN', domain_id)
  },
  async queueDomainProcess (store) {
    if (store.getters.domainQueue.length) {
      try {
        await store.dispatch('getDomain', { domain_id: store.getters.domainQueue[0] })
      } catch (e) {
        console.log('Domain queue error', e, store.getters.domainQueue.length)
      }
      store.dispatch('queueDomainProcess')
    }
  },
  async domainLookup ({ dispatch }, domain) {
    try {
      const data = {
        method: 'domain_availability',
        data: {
          domain: domain
        }
      }
      const response = await dispatch('makecall', data)

      return Promise.resolve(response)
    } catch (e) {
      throw e
    }
  },
  async domainRegister ({ dispatch }, payload) {
    try {
      const data = {
        method: 'domain_register',
        data: payload
      }
      const response = await dispatch('makecall', data)
      return Promise.resolve(response)
    } catch (e) {
      throw e
    }
  },
  async domainLock ({ dispatch }, payload) {
    try {
      return amapi.makecall('domain_lock', { ...payload })
    } catch (e) {
      throw e
    }
  },
  async domainEpp ({ dispatch }, payload) {
    try {
      return amapi.makecall('domain_epp', { ...payload })
    } catch (e) {
      throw e
    }
  },
  async domainAutoRenew ({ dispatch }, payload) {
    try {
      return amapi.makecall('domain_autorenew', { ...payload })
    } catch (e) {
      throw e
    }
  },
  async domainIdProtectRequest ({ dispatch }, payload) {
    try {
      return await amapi.makecall('domain_idprotect', { ...payload })
    } catch (e) {
      throw e
    }
  },
  async domainIdProtectToggle ({ dispatch }, payload) {
    try {
      return amapi.makecall('domain_idprotect_toggle', { ...payload })
    } catch (e) {
      throw e
    }
  },
  async domainNameServer ({ dispatch }, payload) {
    try {
      return amapi.makecall('domain_nameserver', payload)
    } catch (e) {
      throw e
    }
  },
  async getDnsRecords ({ commit }, domainid) {
    try {
      return await amapi.makecall('domain_get_hosts', domainid)
    } catch (e) {
      throw e
    }
  },
  async setDnsRecords ({ commit }, data) {
    try {
      return await amapi.makecall('domain_set_hosts', data)
    } catch (e) {
      throw e
    }
  },
  async domainTransferRequest ({ dispatch }, data) {
    try {
      return await amapi.makecall('domaintransfer_request', data)
    } catch (e) {
      dispatch('reportError', e)
      throw e
    }
  },
  async fetchDomainTransferList ({ commit, dispatch }) {
    try {
      const response = await amapi.makecall('domaintransfer_list')
      commit('SET_DOMAINS_TRANSFER_LIST', response.transfers)
    } catch (e) {
      dispatch('reportError', e)
      throw e
    }
  },
  async fetchDomainTransferView ({ dispatch }, data) {
    try {
      return await amapi.makecall('domaintransfer_view', data)
    } catch (e) {
      dispatch('reportError', e)
      throw e
    }
  },
  async postDomainTransferRestart ({ dispatch }, data) {
    try {
      return await amapi.makecall('domaintransfer_restart', data)
    } catch (e) {
      dispatch('reportError', e)
      throw e
    }
  },
  async postDomainTransferCancel ({ dispatch }, data) {
    try {
      return await amapi.makecall('domaintransfer_cancel', data)
    } catch (e) {
      dispatch('reportError', e)
      throw e
    }
  },
  checkServicesForDomainChange ({ commit, dispatch, rootGetters }) {
    const domainChangeIds = rootGetters.services
      .filter(service => service.domainchange_request > 0)
      .map(service => {
        const requestId = Number(service.domainchange_request)
        return [
          requestId,
          rootGetters.domainChangeRequests.has(requestId)
            ? rootGetters.domainChangeRequests.get(requestId)
            : null
        ]
      })
    if (domainChangeIds.length) {
      commit('SET_DOMAIN_CHANGE_REQUESTS', domainChangeIds)
      // dispatch('checkDomainChangeRequests')

      if (!rootGetters.domainChangeInterval) {
        const interval = setInterval(() => {
          dispatch('checkDomainChangeRequests')
        }, 30000)
        commit('SET_DOMAIN_CHANGE_INTERVAL', interval)
      }
    }
  },
  async checkDomainChangeRequests ({ commit, dispatch, rootGetters }) {
    if (rootGetters.domainChangeRequests.size === 0) {
      dispatch('clearDomainChangeInterval')
      return
    }

    let updateServices = false

    const domainChangeRequests = rootGetters.domainChangeRequests
    for (const id of domainChangeRequests.keys()) {
      const data = {
        method: 'domainchange_view',
        data: {
          id
        }
      }
      try {
        const response = await dispatch('makecall', data)
        if (response.result === 'success' && response.request?.status === 'completed') {
          updateServices = true

          domainChangeRequests.delete(id)
          dispatch('reportSuccess', `Your domain change request to ${response.request.domain_new} has completed.`)
          // reset the domainchange_request for the current hosting
          const hosting = rootGetters.services.find(service => service.id === rootGetters.hosting.id)
          hosting.domainchange_request = 0
          commit('POPULATE_HOSTING', hosting)

          commit('SET_DOMAIN_CHANGE_REQUESTS', [...domainChangeRequests.entries()])
          // clear the interval if no more requests left
          if (domainChangeRequests.size === 0) {
            dispatch('clearDomainChangeInterval')
          }
        } else if (response.result === 'success' && response.request?.status === 'pending') {
          // put the request status data to the store
          domainChangeRequests.set(id, response.request)
          commit('SET_DOMAIN_CHANGE_REQUESTS', [...domainChangeRequests.entries()])
        }
      } catch (e) {
        dispatch('reportError', e)
        console.error(e)
      }
    }

    if (updateServices) {
      await dispatch('getServices', { withDomains: false })
      const hosting = rootGetters.services.find(service => service.id === rootGetters.hosting.id)
      if (hosting) {
        commit('POPULATE_HOSTING', hosting)
      }
    }
  },
  clearDomainChangeInterval ({ commit, rootGetters }) {
    if (rootGetters.domainChangeInterval) {
      clearInterval(rootGetters.domainChangeInterval)
    }
    commit('SET_DOMAIN_CHANGE_INTERVAL', null)
  },
}
